module.exports = __webpack_public_path__ + "img/bg_share_0.1927765e.jpg";